import styled, { css } from 'styled-components';
import { getSpacingToken, getToken } from '@optimus-web/common';
import { BreakpointRange, MEDIA_QUERY, mediaMaxWidth } from '@optimus-web/core';

const MODAL_BODY_PRINT_STYLES = `
    @media print {
        position: static;
        overflow: visible;
        padding: 0px;
    }
`;

/** @deprecated Use NewModalBodyWrapper */
export const ModalBodyWrapper = styled.div<{ padded?: boolean }>`
    background: ${getToken('backgroundStaticFlat')};
    flex: 1 1 auto;
    overflow-y: auto;
    overflow-x: hidden;
    position: relative;

    ${(props) =>
        props.padded === true &&
        css`
            padding: 8px;

            ${mediaMaxWidth(BreakpointRange.Tablet)} {
                padding: 4px;
            }
        `}

    ${MODAL_BODY_PRINT_STYLES}
`;

export const NewModalBodyWrapper = styled.div<{ padded?: boolean }>`
    background-color: ${getToken('backgroundStaticFlat')};
    padding: ${({ padded }) => (padded ? getSpacingToken('300') : 0)}px;
    flex: 1 1 auto;
    overflow-y: auto;
    overflow-x: hidden;
    position: relative;
    ${MEDIA_QUERY.tabletMax} {
        padding: ${({ padded }) => (padded ? getSpacingToken('100') : 0)}px;
    }

    ${MODAL_BODY_PRINT_STYLES}
`;

export const ModalWrapper = styled.div`
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    left: 0;
    overflow: hidden;
    display: flex;
    flex-flow: column;
    height: 100%;

    ${MODAL_BODY_PRINT_STYLES}
`;

export const BackgroundContainer = styled.div`
    display: flex;
    min-height: 100%;
`;
